import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { ContentEntryDisplayData } from '../../model/ContentEntry/ContentEntryDisplayData';
import { DomSanitizer } from '@angular/platform-browser';
import { EmbedVideoService } from 'ngx-embed-video';
import { TextUtils } from '../shared/textutil';
import { BaseComponent } from '../base.component';

@Component({
  selector: 'app-display-content-video',
  templateUrl: './display-content-video.component.html',
  styleUrls: ['./display-content-video.component.css'],
  encapsulation: ViewEncapsulation.None

})
export class DisplayContentVideoComponent implements OnInit {
  @Input() content: ContentEntryDisplayData;
  @Input() timeindex: string;
  theUrl: any;
  public textPart1: string;
  public textPart2: string;

  constructor(private sanitizer: DomSanitizer, private embedService: EmbedVideoService) {
  }

  public getTheVideoUrl() {
    let timeindexstring = "";
    if (this.timeindex) {
      let totalseconds = Number(this.timeindex);
      if (totalseconds > 0) {
        let minutes = Math.floor(totalseconds / 60);
        let seconds = Math.floor(totalseconds % 60);
        timeindexstring = "#t=" + minutes + "m" + seconds + "s";
      }
    }
    this.theUrl = this.embedService.embed_vimeo(this.content.RenderData.VendorVideoID + timeindexstring);
  }

  ngOnInit() {
    this.getTheVideoUrl();
    if (this.content.RenderData.Html && this.content.RenderData.Html.length > 1500) {
      let textUtils = new TextUtils(this.content.RenderData.Html);
      this.textPart1 = textUtils.firstHalf;
      this.textPart2 = textUtils.secondHalf;
    }
  }

}
